import { DASH_BUTTONS, POLICE_LINES } from '../../content/lines/police';
import type { RunState } from '../../game/RunState';
import type { DashChoice } from '../../systems/checkpoint/checkpoints';
import { el, setText } from '../components/el';

const KEYS: Record<string, DashChoice> = { Digit1: 'ten', Digit2: 'twenty', Digit3: 'refuse' };

/** The officer stretches out his hand: give him GH₵10 or GH₵20 (keys 1 / 2) or say no (3). */
export class DashPrompt {
  private readonly root = el('div', 'dash-prompt');
  private readonly say = el('div', 'dash-say');
  private shownFor = -1;
  private visible = false;

  constructor(parent: HTMLElement, private readonly answer: (choice: DashChoice) => void) {
    const buttons = el('div', 'dash-buttons');
    for (const choice of ['ten', 'twenty', 'refuse'] as const) {
      const button = el('button', `dash-button ${choice}`, DASH_BUTTONS[choice]);
      button.type = 'button';
      button.addEventListener('click', () => this.answer(choice));
      buttons.append(button);
    }
    this.root.append(el('div', 'dash-hand', '🤚🚔'), this.say, buttons);
    parent.append(this.root);
    window.addEventListener('keydown', (e) => {
      const choice = KEYS[e.code];
      if (choice && this.visible && !e.repeat) this.answer(choice);
    });
  }

  update(state: RunState): void {
    const cp = state.checkpoint.current;
    this.visible = cp?.phase === 'checking' && cp.dash === 'asking';
    this.root.classList.toggle('show', this.visible);
    if (this.visible && cp && this.shownFor !== cp.id) {
      this.shownFor = cp.id;
      setText(this.say, POLICE_LINES.ask[cp.id % POLICE_LINES.ask.length]!);
    }
  }
}
